<template>
  <div id="gl-export">
    <section class="hero is-primary">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            GL Export Utility
          </h1>
          <h2 class="subtitle">
            Exports a GL Interface by given date, in a workable Sage Format
          </h2>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <div class="columns is-multiline">
          <div class="column is-12">
            <b-field label="Select GL Export Date">
              <b-datepicker
                placeholder="Select Date"
                icon="calendar"
                v-model="selectedDate"
                :date-formatter="(date) => format(date, 'dd/MM/yyyy')"
                :date-parser="(date) => format(date, 'dd/MM/yyyy')"
                :events="glAvailableDates"
                indicators="bars"
              >
                <div class="buttons">
                  <button
                    class="button is-primary"
                    @click="selectedDate = new Date()"
                  >
                    <!-- Todays Date -->
                    <b-icon icon="calendar-today"></b-icon>
                    <span>Today</span>
                  </button>

                  <!-- Clear Selection -->
                  <button class="button is-danger" @click="selectedDate = null">
                    <b-icon icon="close"></b-icon>
                    <span>Clear</span>
                  </button>
                </div>
              </b-datepicker>
            </b-field>
          </div>
          <div class="column is-12">
            <b-button
              v-if="selectedDate != null"
              type="is-primary"
              @click.prevent="submitGlExport"
            >
              Submit
            </b-button>
          </div>

          <!-- GL Export -->
          <div class="column is-12">
            <!-- GL Export - Produce CSV -->
            <exportCSV
              v-if="glData.length"
              :data="glData"
              :name="
                `GL Export - ${currentClient} - ${format(
                  this.selectedDate,
                  'dd-MM-yyyy'
                )}.csv`
              "
            >
              <b-button
                type="is-success"
                class="is-pulled-right"
                icon-left="file-export"
              >
                Export CSV
              </b-button>
            </exportCSV>

            <!-- GL Export - Build table from Data -->
            <b-table
              :data="tableIsEmpty ? [] : glData"
              :striped="true"
              :mobile-cards="true"
              :loading="tableIsLoading"
              :paginated="true"
              :per-page="20"
              default-sort-direction="asc"
              :default-sort="['seqn', 'asc']"
            >
              <template slot-scope="props">
                <b-table-column
                  v-for="(column, index) in glColumns"
                  :key="index"
                  :field="column.name"
                  :label="column.label"
                  sortable
                >
                  {{ props.row[column.name] }}
                </b-table-column>
              </template>

              <!-- GL Export - Show 'Empty Data' placeholder -->
              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <p>
                      <b-icon icon="emoticon-sad" size="is-large"> </b-icon>
                    </p>
                    <p>
                      Nothing here. Please select a GL Export Date and Submit
                    </p>
                  </div>
                </section>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { format } from 'date-fns';
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  name: 'GLExport',
  components: {},
  data: function() {
    return {
      loading: false,
      format,
      selectedDate: null,
      response: '',
      glData: [],
      glColumns: [],
      glAvailableDates: [],
      tableIsLoading: false,
      tableIsEmpty: false,
    };
  },
  computed: {
    ...mapGetters(['currentClient']),
  },
  methods: {
    submitGlExport: async function() {
      this.getGlData();
    },
    getGlData: async function() {
      try {
        this.tableIsLoading = true;
        const sqlDate = format(this.selectedDate, 'yyyy-MM-dd');
        const response = await axios.get(
          `https://utilities-server.ksam.co.uk/gl-export?client=${
            this.currentClient
          }&date=${sqlDate}`
        );

        const data = await response.data;
        this.glData = data.results;
        this.glColumns = data.columns;

        console.log(data);

        if (data.results.length === 0) {
          this.$buefy.toast.open({
            type: 'is-danger',
            message:
              'There was no data found for the selected date, dates with GL Exports available will be highlighted in the calendar.',
            duration: 3000,
          });
        }

        this.tableIsLoading = false;
      } catch (err) {
        // eslint-disable-next-line
        console.log(err);
      }
    },
  },
  async mounted() {
    const response = await axios.get(
      `https://utilities-server.ksam.co.uk/gl-dates?client=${
        this.currentClient
      }`
    );
    const data = await response.data;

    console.log(data);

    if (data.length === 0) {
      this.$buefy.toast.open({
        type: 'is-danger',
        message: 'This client does not appear to have any available GL Exports',
      });
    } else {
      this.glAvailableDates = data.map((date) => new Date(date));
    }
  },
};
</script>

<style></style>
